#@import moment
#@import Booking.Helpers
#@import Booking.Collections.Options
#@import Booking.Collections.Availability
#@import Booking.Collections.PossibleSegments
#@import Booking.Collections.PartySizes
#@import Booking.Collections.Reservations
#@import Booking.Models.Base
#@import Booking.Models.PartySize
#@import Booking.Models.Reservation
#@import Booking.Models.PossibleSegment
#@export Booking.Models.Booker

class Booking.Models.Booker extends Booking.Models.Base

  _loading: {}

  initializeSubCollections: ->
    options =      new Booking.Collections.Options
    availability = new Booking.Collections.Availability
    reservations = new Booking.Collections.Reservations
    partySizes =   new Booking.Collections.PartySizes

    availability.getTimezone = => @getTimezone()

    @listenTo reservations, 'request', _.bind(@booking, this)
    @listenTo reservations, 'sync', _.bind(@booked, this)
    @listenTo reservations, 'error', _.bind(@handleError, this)

    @listenTo availability, 'sync', _.bind(@clearLoadings, this)
    @listenTo availability, 'request', _.bind(@showDateTimeLoading, this)

    @set {options, availability, reservations, partySizes}

  constructor: ({deal, optionId}) ->
    Booking.Models.Base.apply this, arguments

    Booking.Helpers.addTimezoneToMoment(@get('timezoneData'))

    @initializeSubCollections()

    @on 'change:selectedOption', @selectedOptionChanged, this

    # Reset Options
    @resetOptions(deal.options)

  checkAvailabilityWithNewOption: ({date, datetime}) ->
    if datetime or date
      presetWithParams = @buildPresetWithParams {datetime, date}
      @getAvailability().once 'sync', presetWithParams

    if @isBookerDeal()
      {start, end} = Booking.Helpers.getDayRange(datetime || date)
    else
      if datetime || date
        {start, end} = Booking.Helpers.getFullMonthRange(datetime || date, @getTimezone())
      else
        {start, end} = Booking.Helpers.getNowtoNextMonthRange Booking.Helpers.getNowInTimezone(@getTimezone())

    @loadAvailability(start, end)

  checkAvailabilityWithNewOptionAndPreset: ({date, datetime, time}) ->
    if @isBookerDeal()
      {start, end} = Booking.Helpers.getDayRange(datetime || date)
    else
      if datetime || date
        dateMoment = Booking.Helpers.objectInTimezone(datetime || date, @getTimezone())
        {start, end} = Booking.Helpers.getFullMonthRange(dateMoment, @getTimezone())
      else if time and !date
        {start, end} = Booking.Helpers.getNowtoNextMonthRange Booking.Helpers.getNowInTimezone(@getTimezone())

    @loadAvailability(start, end)

  # This should not be called in my reservations
  selectedOptionChanged: (model, value, options) ->
    return if not value
    @resetPartySize()

    if !model.previous('selectedOption') and @getPreset()
      @checkAvailabilityWithNewOptionAndPreset(@getPreset())
    else
      @checkAvailabilityWithNewOption @getAvailabilityParameters()

  getAvailabilityParameters: ->
    times = @getSelectedTimes()
    if times.length > 0
      datetime = times[0].start()

    date = @getSelectedDate()

    return {date, datetime}

  selectDate: (selectedDate) ->
    if moment.isMoment selectedDate
      @setSelectedDate selectedDate

  findAndSelectTime: (timestamp, events) ->
    timeFound = _.find events, (time) -> time.start().unix() is timestamp

    if timeFound?
      @selectTimes([timeFound])
    else
      @showNotice 'time_not_available'

  # Receives moment objects for both initialTime and finalTime
  loadAvailability: (initialTime, finalTime) ->
    selectedOption = @getSelectedOption()

    return unless selectedOption

    optionAvailability = selectedOption.getAvailability()

    # if the option is booker or there is no availability for it, fetch it anyways
    if optionAvailability?.length and not @isBookerDeal()
      @getAvailability().set(optionAvailability)
      @getAvailability().trigger('sync')
    else
      @fetchAvailability(initialTime, finalTime)

  fetchAvailability: (initialTime, finalTime, resetAndRemove = true, alwaysCallback) ->
    # resetAndRemove: By default, we want to reset the collection when fetching.
    # However, if we're fetching the next month's availability,
    # we want to add the response to the collection and not remove the existing data.
    params =
      reset: resetAndRemove
      remove: resetAndRemove
      data:
        initialTime: initialTime.format()
        finalTime:   finalTime.format()
        optionId:    @getSelectedOption().get('uuid')

    params.always = alwaysCallback if alwaysCallback?

    @getAvailability().fetch params

  getNextDate: (date, isDateTime) ->
    notice = nextDate = events = undefined

    events = @getAvailability().getTimesByDate(date)

    # If isDatetime then find if the date has the time
    # if not then it should getNextDateWithAvailabilityAtTimeFromSpecificDate
    hasTime = if isDateTime then @getAvailability().hasTime(date.unix()) else true

    if Booking.Helpers.isDateInFuture(date, @getTimezone()) and events.length > 0 and hasTime
      return {date, events, notice}
    else
      if isDateTime
        nextDate = @getAvailability().getNextDateWithAvailabilityAtTimeFromSpecificDate(date, date.format('HH:mm'))
        if nextDate
          events = @getAvailability().getTimesByDate(nextDate)
        notice = 'next_available_with_time'

      if not nextDate?
        nextDate = @getAvailability().getNextDateWithAvailability()
        if nextDate
          notice = 'next_available'
          events = @getAvailability().getTimesByDate(nextDate)
        else
          notice = 'date_not_available'
          events = []

      return {date: nextDate, events, notice}


#SHOULD REFACTOR

  _selectDateTime: (datetime) ->

    {date, events, notice} = @getNextDate(Booking.Helpers.objectInTimezone(datetime, @getTimezone()), true)

    if date
      @selectDate date
      @findAndSelectTime date.unix(), events
    else
      @resetDateTime()

    @showNotice notice

  _selectDate: (dateString) ->
    {date, events, notice} = @getNextDate(moment.tz(dateString, 'YYYY-MM-DD', @getTimezone()), false)

    if date
      @selectDate date
      @resetTime()
    else
      @resetDateTime()

    @showNotice notice

  _selectTime: (time) ->
    # find next date with availability at that time
    nextDateTime = @getAvailability().getNextDateWithAvailabilityAtTime(time)
    if nextDateTime?
      events = @getAvailability().getTimesByDate(nextDateTime)

      @selectDate nextDateTime

      @findAndSelectTime nextDateTime.unix(), events

      @showNotice 'next_available_with_time'
    else
      @resetDateTime()
      @showNotice 'time_not_available'

#SHOULD TEST
  buildPresetWithParams: ({date, time, datetime}) => =>
    if datetime
      return @_selectDateTime(datetime)

    if date and not time
      return @_selectDate(date)

    if time and not date
      return @_selectTime(time)

    @resetDateTime()

  presetDateTime: ({datetime, date, time}) ->
    presetWithParams = @buildPresetWithParams {date, time, datetime}

    option = @getSelectedOption()
    if option?.getAvailability()
      presetWithParams()
    else
      @getAvailability().once 'sync', presetWithParams

  selectTimes: (times = []) ->
    @clearLoading('selectedTimes')

    time.select() for time in times
    @setSelectedTimes times

  isDealNotYetOpen: ->
    @getDeal()?.status is 'not_yet'

  isARSE: ->
    @getSelectedOption()?.isARSE()

  isG3: ->
    @getSelectedOption()?.isG3()

  booked: ->
    @notBooking() unless @getBookAndBuy() # keep state as "busy" when booked from the deal page

  hasSelectedTime: ->
    @getSelectedTimes().length > 0

  needQuestionsAnswers: ->
    @requireQuestion() and not @getQuestionsAnswer()

  isReadyToBook: ->
    return false if @isDealNotYetOpen()

    needPhoneNumber = @requirePhone() and not @getPhoneNumber()

    needPartySize = @requirePartySize() and not @getSelectedPartySize()

    @hasSelectedTime() and @getSelectedOption()? and not needPhoneNumber and not @needQuestionsAnswers() and not needPartySize

  showNotice: (notice) ->
    @getAvailability().trigger 'error', notice if notice?

  handleError: ->
    @notBooking()

  clearError: ->
    @unset 'error'
    this

  resetReservations: (reservations = []) ->
    @getReservations().reset(reservations)
    this

  createReservation: ->
    @setReservation(new Booking.Models.Reservation)
    @getReservation()

  setReservation: (reservation) ->
    @resetReservations([reservation])
    this

  unsetReservation: ->
    @resetReservations()
    this

  getMerchantPhoneNumber: ->
    @getSelectedOption()?.getRedemptionLocation()?.phoneNumber

  getTimezone: ->
    @getSelectedOption()?.getLocalBookingSettings().getTimezone()

  getSettingsDefinitionVersion: ->
    @getSelectedOption()?.getLocalBookingSettings().getDefinitionVersion()

  getMinLeadTime: ->
    @getSelectedOption()?.getLocalBookingSettings().getMinLeadTime()

  getMaxLeadTime: ->
    @getSelectedOption()?.getLocalBookingSettings().getMaxLeadTime()

  getPartySizeSettings: ->
    @getSelectedOption()?.getPartySizeSettings()

  getPhoneSettings: ->
    @getSelectedOption()?.getPhoneSettings()

  getTextNotificationsSettings: ->
    @getSelectedOption()?.getTextNotificationsSettings()

  getQuestionsSettings: ->
    @getSelectedOption()?.getQuestionsSettings()

  getQuestion: ->
    @getFirstQuestionSettings()?.getLabel()

  requirePartySize: ->
    @getPartySizeSettings()?.isRequired()

  requirePhone: ->
    @getPhoneSettings()?.isRequired() and @getShowAdditionalAttributes()

  requireTextNotifications: ->
    @getTextNotificationsSettings()?.isRequired()

  requireQuestion: ->
    @getFirstQuestionSettings()?.isRequired() and @getShowAdditionalAttributes()

  resetOptions: (options) ->
    @getOptions().reset(options, {silent: true})

  resetOption: ->
    defaultOption = if @hasMultipleOptions() then null else @getOptions().first()
    @setSelectedOption defaultOption

  resetPartySize: ->
    if @requirePartySize()
      currentSelection = @getSelectedPartySize()
      partySizes = @getPartySizeSettings().allowedValues()

      @getPartySizes().reset _.map partySizes, (partySize) -> {partySize}

      if currentSelection in partySizes
        @setSelectedPartySize(currentSelection)
      else
        @setSelectedPartySize(null)

#TESTED
  hasSelection: ->
    !!(@getSelectedDate() or @getSelectedTimes().length > 0)

  clearLoadings: ->
    @clearLoading('selectedTimes')
    @clearLoading('selectedDate')
    @trigger 'loadingEvent'

  resetDateTime: ->
    @resetDate()
    @resetTime()

  resetDate: ->
    @setSelectedDate undefined
    this

  resetTime: ->
    @selectTimes []
    this

  getReservation: ->
    @getReservations().first()

  getFirstQuestionSettings: ->
    @getQuestionsSettings()?[0] # Only support one question for now

  presetOption: (optionId) ->
    option = @getOptions().get(optionId)

    # Safety check in case the option doesn't actually exists
    # Should throw an error instead
    if option
      @setSelectedOption(option)
    else
      @resetOption()

  preset: ({optionId, datetime, date, time, partySize, questionsAnswer, phoneNumber, textNotifications}) ->
    if datetime? or date? or time?
      @setPreset({datetime, date, time})
      @presetDateTime({datetime, date, time})
    @presetOption(optionId)
    @setSelectedPartySize(partySize) if partySize?

    # Phone and Question can't rely on change:{attribute} events since their model values change as the user types.
    # Triggering these manual events allows those views to render/update on preset only.
    @setPhoneNumber(phoneNumber) if phoneNumber?
    @trigger 'phoneNumber:preset'
    @setQuestionsAnswer(questionsAnswer) if questionsAnswer?
    @trigger 'questionsAnswer:preset' if questionsAnswer?

    @setTextNotifications(textNotifications) if textNotifications?

  isReadyToBuy: ->
    @getSelectedOption()?

  isBookerDeal: ->
    _.some @getDeal()?.options, @isBookerOption

  isBookerOption: (option) ->
    option.localBookingSettings?.flags?.third_party_name is Booking.Models.Booker.BOOKER_THIRD_PARTY_NAME

  isMultiWindow: ->
    _.some @getDeal()?.options, @isMultiWindowOption

  isMultiWindowOption: (option) ->
    Booking.Models.Booker.MULTIWINDOW_FLAG in (option.schedulerOptions?.enabledFeatures || [])

  reset: ->
    @resetOption()
    @resetTime()

  hasMultipleOptions: ->
    @getOptions().length > 1

  booking: ->
    @setIsBooking true

  notBooking: ->
    @setIsBooking false

  isPartialIntent: ->
    partialIntent = @getPartialIntent()
    # assumption, if no partial_intent parameter is passed, we assume is partial intent
    if partialIntent?
      return partialIntent
    else
      return true

# Loading Code
  showDateTimeLoading: ->
    @setLoading('selectedTimes')
    @setLoading('selectedDate')

    @trigger 'loadingEvent'

  isDateTimeLoading: ->
    return !!(@getLoading('selectedDate') or @getLoading('selectedTimes'))

  getLoading: (attribute) ->
    return @_loading[attribute]

  setLoading: (attribute) ->
    @_loading[attribute] = true

  clearLoading: (attribute) ->
    delete @_loading[attribute]

  toggleTextNotifications: ->
    @setTextNotifications(if @getTextNotifications() is 'true' then 'false' else 'true')

# Deal Getters
  isFoodAndDrink: -> @getDeal()?.isFoodAndDrink
  isHBW: -> @getDeal()?.isHBW

# Passthrough Setters
  setSelectedOption: (selectedOption, options) -> @set {selectedOption}, options

# Basic Setters
  setError: (error) -> @set {error}
  setIsBooking: (isBooking) -> @set {isBooking}
  setPartialIntent: (partialIntent) -> @set {partialIntent}
  setPhoneNumber: (phoneNumber) -> @set {phoneNumber}
  setQuestionsAnswer: (questionsAnswer) -> @set {questionsAnswer}
  setSelectedDate: (selectedDate) -> @set {selectedDate}
  setSelectedPartySize: (selectedPartySize) ->
    @set {selectedPartySize: if selectedPartySize? then parseInt(selectedPartySize, 10) else undefined}
  setSelectedTimes: (selectedTimes) -> @set {selectedTimes}
  setShowAdditionalAttributes: (showAdditionalAttributes) -> @set {showAdditionalAttributes}
  setTextNotifications: (textNotifications) -> @set {textNotifications}
  setPreset: (preset) -> @set {preset}

# Basic Getters
  getAvailability: -> @get('availability')
  getBookAndBuy: -> @get('bookAndBuy')
  getDeal: -> @get('deal')
  getError: -> @get('error')
  getGrouponId: -> @get('grouponId')
  getIsBooking: -> @get('isBooking')
  getIsDTF: -> @get('isDTF')
  getMerchant: -> @get('merchant')
  getOptions: -> @get('options')
  getOrderId: -> @get('orderId')
  getPartialIntent: -> @get('partialIntent')
  getPartySizes: -> @get('partySizes')
  getPhoneNumber: -> @get('phoneNumber')
  getQuestionsAnswer: -> @get('questionsAnswer')
  getReschedule: -> @get('reschedule')
  getReservations: -> @get('reservations')
  getSelectedDate: -> @get('selectedDate')
  getSelectedOption: -> @get('selectedOption')
  getSelectedPartySize: -> @get('selectedPartySize')
  getSelectedTimes: -> @get('selectedTimes') || []
  getShowAdditionalAttributes: -> @get('showAdditionalAttributes')
  getTextNotifications: -> @get('textNotifications')
  getUserId: -> @get('userId')
  getPreset: -> @get 'preset'

#WONT REFACTOR NOW

  book: ->
    if @isReadyToBook()
      @booking()
      reservation = @getReservation() or @createReservation()
      selectedOption = @getSelectedOption()

      possibleSegments = _.map(@getSelectedTimes(), Booking.Models.PossibleSegment::createFromTimeModel)
      possibleSegmentsCollection = new Booking.Collections.PossibleSegments possibleSegments
      possibleSegmentsCollection.getTimezone = => @getTimezone()

      reservationData =
        possibleSegments: possibleSegmentsCollection
        dealId: @getDeal().id
        optionId: selectedOption.id
        orderId: @getOrderId()
        userId: @getUserId()
        definitionVersion: @getSettingsDefinitionVersion()

      reservationData[@getPartySizeSettings().getName()] = @getSelectedPartySize() if @requirePartySize()
      reservationData[@getPhoneSettings().getName()] = @getPhoneNumber() if @requirePhone()
      reservationData[@getTextNotificationsSettings().getName()] = @getTextNotifications() if @requireTextNotifications()
      reservationData[@getFirstQuestionSettings().getName()] = @getQuestionsAnswer() if @requireQuestion()

      reservation.set(reservationData)

      # Hack: Force create new reservation only for PrePurchase since reschedule feature required but not supported by API
      #       (the previous reservation, in `locked` status, will automatically be dropped after xx minutes)
      #       see https://bugs.groupondev.com/browse/OBOOK-302
      reservation.unset('id') unless reservationData.orderId

      reservation.save()
    else
      @trigger 'buy', this


Booking.Models.Booker.BOOKER_THIRD_PARTY_NAME = 'booker'
Booking.Models.Booker.MULTIWINDOW_FLAG = 'multiWindow'
